import { render } from "./ComercialDatosDatos.vue?vue&type=template&id=1bcaadb6"
import script from "./ComercialDatosDatos.vue?vue&type=script&lang=js"
export * from "./ComercialDatosDatos.vue?vue&type=script&lang=js"

import "./ComercialDatosDatos.vue?vue&type=style&index=0&id=1bcaadb6&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__